/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Discount } from './Discount';
// @ts-ignore
import {
// @ts-ignore
    DiscountFromJSON,
// @ts-ignore
    DiscountFromJSONTyped,
// @ts-ignore
    DiscountToJSON,
} from './Discount';

/**
 * 
 * @export
 * @interface OrderItemPromotion
 */
export interface OrderItemPromotion {
    /**
     * 
     * @type {string}
     * @memberof OrderItemPromotion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPromotion
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPromotion
     */
    name: string;
    /**
     * 
     * @type {Array<Discount>}
     * @memberof OrderItemPromotion
     */
    discounts: Array<Discount>;
}

/**
 * Check if a given object implements the OrderItemPromotion interface.
 */
// @ts-ignore
export function instanceOfOrderItemPromotion(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "discounts" in value;

    return isInstance;
}

// @ts-ignore
export function OrderItemPromotionFromJSON(json: any): OrderItemPromotion {
    return OrderItemPromotionFromJSONTyped(json, false);
}

// @ts-ignore
export function OrderItemPromotionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderItemPromotion {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'discounts': ((json['discounts'] as Array<any>).map(DiscountFromJSON)),
    };
}

// @ts-ignore
export function OrderItemPromotionToJSON(value?: OrderItemPromotion | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'name': value.name,
        'discounts': ((value.discounts as Array<any>).map(DiscountToJSON)),
    };
}

